import EncounterDetails from './EncounterDetails';

export default EncounterDetails;
